import { FC } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { HOMEPAGE_PATH } from 'utils/consts/path'

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 48px;
  height: 48px;
  border-bottom: 1px solid var(--grey-80, #41435b);
  background: var(--grey-100, #121432);
`

const Logo = styled(Link)`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`

const Button = styled.button`
  all: unset;
  display: flex;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

interface HeaderProps {
  onClose: () => void
}

const Header: FC<HeaderProps> = ({ onClose }) => {
  return (
    <Wrapper>
      <Logo to={HOMEPAGE_PATH} onClick={onClose}>
        <WWLLogo />
      </Logo>
      <Button type='button' onClick={onClose}>
        <CloseIcon />
      </Button>
    </Wrapper>
  )
}

// prettier-ignore
const WWLLogo = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='136' height='24' fill='none' viewBox='0 0 136 24'>
    <path fill='#E7E7EA' fillRule='evenodd'
          d='M2.48 24V0h19.03v18.7l-5.3 5.3H2.49ZM16.6 6.85h-2.53c-.23.46-.7.77-1.23.77H7.39v-2.7h5.45c.54 0 1 .39 1.23.85h2.53v1.08Zm-.54 14.92v-3.3h3.3l-3.3 3.3ZM15 17.47h4.83V1.61H4.1v20.76H15v-4.92Zm-.92-1.93h2.53v-1.08h-2.53c-.23-.46-.7-.84-1.23-.84H7.39v2.69h5.45c.54.07 1-.31 1.23-.77Zm2.53-4.39h-2.53c-.23.54-.7.85-1.23.85H7.39V9.23h5.45c.54 0 1 .39 1.23.85h2.53v1.07ZM45.84 7.7a4.3 4.3 0 0 1 4.3 4.3 4.3 4.3 0 0 1-4.3 4.3h-.38a4.3 4.3 0 0 1-4.3-4.3 4.3 4.3 0 0 1 4.3-4.3h.38Zm9.52 7.3-.46-.77c-.08-.08-.16-.15-.23-.3-.04-.05-.08-.06-.12-.08l-.11-.08c-.08-.08-.23-.08-.31-.08h-.7V16h-2.3V7.85h4c1.6 0 2.84 1.3 2.84 2.84 0 1-.46 1.85-1.3 2.39l.07.07c.15.08.23.23.3.39 0 .15.08.23.16.3.04.04.1.06.15.08.06.02.12.04.16.08.15.08.23.08.38.08h.54V16l-.08.08c-.04 0-.06.02-.08.04-.02.01-.03.03-.07.03l-.15.04c-.24.06-.44.12-.7.12-.3 0-.61-.08-.84-.16a1.81 1.81 0 0 1-.7-.46 1.82 1.82 0 0 1-.45-.69Zm-20.19-2.85-1.45 3.93V16h-2.15L29.1 7.85h2.46l1.3 4.69 1.84-4.7h.92l1.85 4.7 1.3-4.62h2.46l-2.46 8.16h-2.15l-1.46-3.93Zm18.27-.61V10h1.38a.77.77 0 0 1 0 1.54h-1.38Zm-7.75 2.61A2.2 2.2 0 0 1 43.54 12c0-1.15 1-2.15 2.15-2.15s2.15 1 2.15 2.15-1 2.15-2.15 2.15Zm19.8-6.23h3.53c2.3 0 4.14 1.85 4.14 4.08a4.12 4.12 0 0 1-4.14 4.08h-3.53V7.92Zm3.37 6h-1V10h1c1.08 0 2 .85 2 2 0 1.08-.92 1.92-2 1.92Zm-9.51-6h2.3v6h2.92v2.16h-5.22V7.92Zm22.71-.07 1.85 4.69 1.3-4.7h2.46L85.2 16h-2.15l-1.46-3.92L80.15 16H78l-2.46-8.15H78l1.3 4.69 1.84-4.7h.92Zm8.83 8.23h-2.3V7.92h2.3v8.16Zm6.68-3.93-3-4.15-.07-.08h-2v8.16h2.23v-4.39L97.8 16l.07.08h1.92V7.92h-2.22v4.23Zm9.05-4.23v2h-2.92V11h2.54v1.92h-2.53V14h2.91v2.08h-5.22V7.92h5.22Zm17.04 2.93.23.07c1.07.23 2.76.7 2.76 2.62 0 1.61-1.23 2.7-3.3 2.7-2 0-3.3-1-3.3-2.7v-.16h2.38v.16c0 .3.23.7.92.7.69 0 .92-.4.92-.7 0-.39-.61-.62-1.38-.77h-.08c-1.16-.31-2.6-.7-2.6-2.54 0-1.23.76-2.54 3.06-2.54 2.23 0 3.07 1.31 3.07 2.54v.15h-2.3v-.15c0-.54-.61-.61-.77-.61-.15 0-.77.07-.77.61 0 .3.47.46 1.16.62Zm-4.6 5.23h-2.31V7.92h2.3v8.16Zm-8.53-8.16h2.3v6h2.92v2.16h-5.22V7.92Zm16.35 0v2.16h2.15v6.07h2.3v-6.07h2.15V7.92h-6.6Z'
          clipRule='evenodd' />
  </svg>
)

// prettier-ignore
const CloseIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
    <path fill='#fff' fillRule='evenodd'
          d='M20.7 3.3a1 1 0 0 1 0 1.4L13.42 12l7.3 7.3a1 1 0 0 1-1.42 1.4L12 13.42l-7.3 7.3a1 1 0 0 1-1.4-1.42l7.28-7.3-7.3-7.3A1 1 0 0 1 4.7 3.3l7.3 7.28 7.3-7.3a1 1 0 0 1 1.4 0Z'
          clipRule='evenodd' />
  </svg>
)

export default Header
